import { Router } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SharedServices } from '../../../shared/services/shared.services';
import { ColumnFilterDialogComponent } from '../../../shared/component/search-filter-modal/column-filter-dialog/column-filter-dialog.component';
import { DelegationofauthorityService } from '../../../services/delegationofauthority/delegationofauthority.service';
import { IType, IDepartments, IDoaCategory,IDivisions, IDOA_InactiveAndActiveVW } from '../../../interface/delegationofauthority/searchdoa';
import { CommonService } from '../../../services/common/common.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatDialog } from '@angular/material/dialog';
import { LookupComponent } from '../../../shared/component/look-up/lookup.component'; 

@Component({
  selector: 'app-searchdoadatabasereport',
  templateUrl: './searchdoadatabasereport.component.html',
  styleUrls: ['./searchdoadatabasereport.component.css'],
  imports: [CommonModule, FormsModule, MatPaginatorModule, MatTableModule, MatProgressSpinner, LookupComponent]
})
export class SearchdoadatabasereportComponent implements OnInit {
  filteredTypes: IType[] = [];
  filteredDepartments: IDepartments[] = [];
  filteredDoaCategory: IDoaCategory[] = [];
  filteredDivisions: IDivisions[] = [];
  inactiveAndActiveVWData: IDOA_InactiveAndActiveVW[] = [];
  dataSource = new MatTableDataSource<IDOA_InactiveAndActiveVW>(this.inactiveAndActiveVWData);
  selectedType: string = ''; 
 // rptTableName: string = 'DOA_VW_ACTIVE'; 
  loggedUserCai: string = '';
  showNewReportForm: boolean = false;
  isPreviewDisabled: boolean = false;
  submitFormFlag: boolean= false;
  showPaginator: boolean = false;
  showTable: boolean = false;
  newReportTitle: string = '';
  selectedFields: string[] = [];
  availableFields: string[] | null = null;
  //availableFields: string = '';
  userInfo = { surname: '', otherNames: '', empEmail: '', costCenter: '', reportToEmail: '' };
  predefinedReports: any[] = [];
  isActive: boolean = false;
  saveDefinition: boolean = false;
  reportType: string = 'P';
  reportName: string = '';
  recordsPerPage: number = 10;
  showFields: boolean = false;
  isLoading: boolean = false; 
  displayedColumns: string[] = []; 
  displayedColumnsWithSerialNo: string[] = ['serialNo', ...this.displayedColumns];
  selectedDepartment: string = '';
  selectedDivision: string = '';
  selectedDoaCategory: string = '';
  selectedDoaType: string = '';
  error: string | null = null;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  constructor(private router: Router, private delegationService: DelegationofauthorityService, private sharedService: SharedServices, private commonService: CommonService,  private dialog: MatDialog) { }

  ngOnInit(): void {
    this.showNewReportForm = false;    
    this.isPreviewDisabled = false; 
   
    this.displayedColumns = ["surname", "firstname","costCenter","divisionName","deptName","reportsToEmailAddress"]; 
    this.displayedColumnsWithSerialNo = ['serialNo',"surname", "firstname","costCenter","divisionName","deptName","reportsToEmailAddress"]; 
    this.getinitialDataForPage();
  }

  getinitialDataForPage(): void {
    this.dropdownValues();   
  //   this.commonService.getAvailableColumnNamesVWTable().subscribe(
  //   (data: string) => {
  //     this.availableFields = data.split(';');
  //   },
  //   (error) => {
  //     console.error('Error fetching available column names', error);
  //   }
  // );

  
  // this.commonService.getAvailableColumn().subscribe(
  //   (data: string) => {
  //     this.availableFields = data;
  //   },
  //   (error) => {
  //     console.error('Error fetching available column names', error);
  //   }
  // );
   // this.availableFields = [ "employeeNo", "cai", "surname", "firstname", "middlename", "preferredName", "initials", "jobTitle", "phoneExt","phonelocation", "locationidHr", "locationName", "employeeTypeName",  "companyName", "reportsToEmailAddress","unitName","sectionName","divisionName","deptcode","deptName", "approvercai", "costCenter", "employmentDate", "nationality", "emailAddress", "altEmailAddress", "catCode", "catName", "subCatCode", "subCatName", "subCatNote", "typeCode", "typeName", "noteCode", "dollar", "enteredByCai", "enteredDate"];
  this.availableFields = ["cai","emailAddress", "altEmailAddress","surname", "firstname", "middlename", "preferredName","jobTitle","locationName","reportsToEmailAddress","divisionName","deptName","costCenter","catName","subCatName", "subCatNote","typeName"];
}

  onSelectedResult(result: any): void {
    this.userInfo.surname = result.surname;
    this.userInfo.otherNames = result.firstname + ' ' + result.middlename;
    this.userInfo.empEmail = result.emailAddress;
  }

  submit(): void {
    if(this.submitFormFlag){
      this.isLoading = true;
      this.showTable = false;
      this.showNewReportForm = true;
      this.loggedUserCai = this.sharedService.getloggedUserCai();
      // if (!this.isActive) {
      //   this.rptTableName = 'DOA_VW';
      // }
      
      const dataValidation = {
          surname: this.userInfo.surname,
          otherNames: this.userInfo.otherNames,
          empEmail: this.userInfo.empEmail,
          costCenter: this.userInfo.costCenter,
          reportToEmail: this.userInfo.reportToEmail,
          department: this.selectedDepartment,
          division: this.selectedDivision,
          Category: this.selectedDoaCategory,
          doaTypes: this.selectedDoaType
        }; 
      
      const formData = {
        surname: this.userInfo.surname,
        otherNames: this.userInfo.otherNames,
        empEmail: this.userInfo.empEmail,
        costCenter: this.userInfo.costCenter,
        reportToEmail: this.userInfo.reportToEmail,
        department: this.selectedDepartment,
        division: this.selectedDivision,
        Category: this.selectedDoaCategory,
        doaTypes: this.selectedDoaType,
        isActive: this.isActive,
        selectedReport: this.reportType
      };
      const allFieldsEmpty = Object.values(dataValidation).every(value => !value);

      if (allFieldsEmpty) {
        this.sharedService.openModal('Message', 'Please select field.');
        this.isLoading = false;
        return;
      }
            
      this.delegationService.getVwPerviewReportData(formData).subscribe(
        (response: any) => { 
          if(response){
            this.inactiveAndActiveVWData = response;
            this.dataSource.data = this.inactiveAndActiveVWData; 
            this.showPaginator = true;
            this.dataSource.paginator = this.paginator; 
            this.error = null;
            this.isLoading = false;
            this.showTable = true;
          }        
          else{
            this.error = 'No match record found!';
          }
        },
        (error: any) => {
          this.error = 'No match record found!';
          this.isLoading = false;
          this.showPaginator = false;
        }
      );
    }
  }

  setTableName(): void {
    this.isActive = !this.isActive;
    // if (!this.isActive) {
    //   this.rptTableName = 'DOA_VW';
    // }
  }


  onPageChange(event: PageEvent): void {
    this.recordsPerPage = event.pageSize;
    this.dataSource.paginator = this.paginator;
  }

  navigateToDisplayPage(employeeNo: string): void {
    this.router.navigate(['/DOA/DisplayPage'], { queryParams: { employeeNo } });
  }
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }
  downloadExcel(): void {
    // Get currently filtered data and displayed columns
    const data = this.dataSource.filteredData.map((row) => {
      const rowData: any = {};
      this.displayedColumns.forEach((col) => {
        // Type assertion ensures `col` is a key of IDOA_InactiveAndActiveVW
        rowData[col] = (row as Record<string, any>)[col];
      });
      return rowData;
    });
  
    // Format data and request the service for Excel download
    this.delegationService.getVwPerviewReportWorkSheet(data).subscribe(
      (blob: Blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'DOA_Perview_Report.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
      },
      (error: any) => {
        console.error('Error downloading Excel file', error);
      }
    );
  }

  dropdownValues() {
    this.delegationService.getDepartmentsFromcloudService().subscribe(
      (data: any) => {
        const depts = data.value; 
        if (Array.isArray(depts)) {
          this.filteredDepartments = depts.filter((department: IDepartments) => 
            department && 
            department.id && 
            department.deptName && 
            department.deptName.trim().length > 0
          );
        } else {
          console.error('Expected an array but got:', depts);
        }
      },
      (error) => {
        console.error('Error fetching departments:', error);
      }
    );
  
    this.delegationService.getPredefinedReport().subscribe(
      (data: any[]) => {
        this.predefinedReports = data.filter(report => report && Object.keys(report).length > 0);
      },
      (error) => {
        console.error('Error fetching Predefined Report', error);
      }
    );
  
    this.delegationService.getDOATypes().subscribe(
      (data: IType[]) => {
        this.filteredTypes = data.filter((type: IType) => 
          type && 
          type.typeName && 
          type.typeName.trim().length > 0
        );
      },
      (error) => {
        console.error('Error fetching DOA Type', error);
      }
    );
  
    this.delegationService.getDoaCategory().subscribe(
      (data: IDoaCategory[]) => {
        this.filteredDoaCategory = data.filter((category: IDoaCategory) => 
          category && 
          category.catName && 
          category.catName.trim().length > 0
        );
      },
      (error) => {
        console.error('Error fetching DOA Category', error);
      }
    );
  }
  
  fetchDivisions(id: string): void {
    this.delegationService.getSepficDivisionsFromcloudService(id).subscribe(
      (response: any) => {
        const divisions = response.value; 
        if (Array.isArray(divisions)) {
          this.filteredDivisions = divisions.filter((division: IDivisions) =>
            division &&
            division.id && 
            division.divisionName &&
            division.divisionName.trim().length > 0
          );
        }
      },
      (error) => {
        console.error('Error fetching Divisions', error);
      }
    );
  }
  
  
  openColumnFilterDialog(): void {
    const dialogRef = this.dialog.open(ColumnFilterDialogComponent, {
      width: '550px',
      height: '470px',
      data: {
        availableFields: this.availableFields,
        selectedFields: this.displayedColumns,
      },
    });

    dialogRef.afterClosed().subscribe((result: string[]) => {
      if (result) {
        this.displayedColumns = result;
        this.displayedColumnsWithSerialNo = ['serialNo', ...this.displayedColumns];
      }
    });
  }
}
